/**
 * Home Credit (https://www.homecredit.vn/)
 *
 * Copyright © 2018-present HomeCredit, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// import { preScoreRouteMaps } from './preScore/routeConfig';

const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '/internal/login',
      load: () => import('./internal/login'),
    },
    {
      path: '/duyet-vay-thanh-cong',
      load: () =>
        import(/* webpackChunkName: 'new-user-success' */ './new-user/success'),
    },
    {
      path: '/khong-co-khoan-vay-phu-hop',
      load: () =>
        import(/* webpackChunkName: 'new-user-no-offer' */ './new-user/no-offer'),
    },
    {
      path: '/khoan-vay-bi-tu-choi',
      load: () =>
        import(/* webpackChunkName: 'new-user-reject' */ './new-user/reject'),
    },
    {
      path: '/dang-tim-khoan-vay',
      load: () =>
        import(/* webpackChunkName: 'new-user-waiting' */ './new-user/waiting'),
    },
    {
      path: '/internal/uploadsale',
      load: () => import('./internal/uploadSale'),
    },
    {
      path: '/danh-sach-goi-vay',
      load: () => import('./user/HasOffer'),
    },
    {
      path: '/da-tim-thay-khoan-vay-moi',
      load: () => import('./user/HasOffer'),
    },
    // LP-2009: replacement map with pos selection
    // {
    //   path: '/map/:id?',
    //   load: () => import('./map'),
    // },

    // LP-4095 | Decommission APIs
    // {
    //   path: '/map/:id?',
    //   load: () => import('./Pos'),
    // },
    // {
    //   path: '/chon-lich-hen/:id?',
    //   load: () => import('./Pos/Appointment'),
    // },
    // {
    //   path: '/chon-cua-hang-thanh-cong/:id',
    //   load: () => import('./Pos/Success'),
    // },

    // {
    //   path: '/ho-so-qua-han',
    //   load: () => import('./Pos/ContractCancelled'),
    // },
    {
      path: '/sa-promo',
      load: () => import('./link'),
    },
    // {
    //   path: '/sa-register/login',
    //   load: () => import('./register/login'),
    // },
    // {
    //   path: '/sa-register/dashboard',
    //   load: () => import('./register/dashboard'),
    // },
    {
      path: '/sale-promo',
      load: () => import('./link/non-tipper'),
    },
    {
      path: '/sa-register/login',
      load: () => import('./register/login'),
    },
    {
      path: '/sa-register/dashboard',
      load: () => import('./register/dashboard'),
    },
    // ...preScoreRouteMaps,
    {
      path: '/tien-mat-du-phong-va-vuot-troi',
      load: () =>
        import(/* webpackChunkName: 'exceedSaving' */ './staticPages/exceedSaving'),
    },
    {
      path: '/styleguide',
      load: () => import('./styleguide'),
    },
    {
      path: '/:sa',
      load: () => import('./clz/0bod'),
    },
    {
      path: '/sa/:code',
      load: () => import('./clz/0bod'),
    },
    {
      path: '/:step/:sa?',
      load: () => import('./clz/0bod'),
    },
    {
      path: '',
      load: () => import(/* webpackChunkName: 'home' */ './clz/0bod'),
    },
    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Untitled Page'} - www.homecredit.vn`;
    route.description = route.description || 'ACL - Vay tiờn mặt';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: import('./error').default,
  });
}

export default routes;
